export const BRAND_ID = 'DB20FA2B-DAD8-489D-97C3-F03AB89F0D53';

